<template>
    <div class="benefits-page">
        <div>
            <p style="color:#fff; text-align:center">A planilha abaixo de benefícios no menu explica o que você "ganha" ao preencher cada bloco do cadastro.</p>
            <b-table responsive :fields="fields" :items="items">
                <template #head(heading2)="data">
                    <div v-html="data.label"></div>
                </template>

                <template #head(heading3)="data">
                    <div v-html="data.label"></div>
                </template>

                <template #head(heading4)="data">
                    <div v-html="data.label"></div>
                </template>

                <template #head(heading5)="data">
                    <div v-html="data.label"></div>
                </template>

                <template #head(heading6)="data">
                    <div v-html="data.label"></div>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BenefitsPage',
    data() {
        return {
            fields: [
                {
                    key: 'heading1',
                    label: 'QUAIS SÃO OS BENEFÍCIOS DE SE PREENCHER CADA BLOCO DO CADASTRO?',
                    stickyColumn: true
                },
                { key: 'heading2', label: 'VISUALIZA O MAPA' },
                {
                    key: 'heading3',
                    label: `
                        <ul>
                            <li>VISUALIZA O MAPA</li>
                            <li>VISUALIZA O NOME DOS CADASTRADOS (POTÊNCIAS/INVESTIDORES)</li>
                            <li>APARECE NO MAPA</li>
                            <li>TEM ACESSO AOS FILTROS DAS PERGUNTAS RESPONDIDAS (visualiza dos outros somente aquilo que preencheu no próprio cadastro, desde que tenha respondido 70% do bloco)</li>
                            <li>PODE ENVIAR CONVITES</li>
                        </ul>
                    `
                },
                {
                    key: 'heading4',
                    label: `
                        <ul>
                            <li>VISUALIZA O MAPA</li>
                            <li>VISUALIZA O NOME DOS CADASTRADOS (POTÊNCIAS/INVESTIDORES)</li>
                            <li>APARECE NO MAPA</li>
                            <li>TEM ACESSO AOS FILTROS DAS PERGUNTAS RESPONDIDAS (visualiza dos outros somente aquilo que preencheu no próprio cadastro, desde que tenha respondido 70% do bloco)</li>
                            <li>PODE ENVIAR CONVITES</li>
                            <li>PODE FAZER CONEXÕES</li>
                            <li>ENVIA E RECEBE AVALIAÇÕES</li>
                        </ul>
                    `
                },
                {
                    key: 'heading5',
                    label: `
                        <ul>
                            <li>VISUALIZA O MAPA</li>
                            <li>VISUALIZA O NOME DOS CADASTRADOS (POTÊNCIAS/INVESTIDORES)</li>
                            <li>APARECE NO MAPA</li>
                            <li>TEM ACESSO AOS FILTROS DAS PERGUNTAS RESPONDIDAS (visualiza dos outros somente aquilo que preencheu no próprio cadastro, desde que tenha respondido 70% do bloco)</li>
                            <li>PODE ENVIAR CONVITES</li>
                            <li>PODE FAZER CONEXÕES</li>
                            <li>ENVIA E RECEBE AVALIAÇÕES</li>
                            <li>PODE TROCAR MENSAGENS</li>
                            <li>PODE EXPORTAR DADOS DA PLATAFORMA</li>
                            <li>PODE SER CONVIDADO PARA EVENTOS EXCLUSIVOS</li>
                        </ul>
                    `
                },
                {
                    key: 'heading6',
                    label: `
                        <ul>
                            <li>VISUALIZA O MAPA</li>
                            <li>VISUALIZA O NOME DOS CADASTRADOS (POTÊNCIAS/INVESTIDORES)</li>
                            <li>APARECE NO MAPA</li>
                            <li>TEM ACESSO AOS FILTROS DAS PERGUNTAS RESPONDIDAS (visualiza dos outros somente aquilo que preencheu no próprio cadastro, desde que tenha respondido 70% do bloco)</li>
                            <li>PODE ENVIAR CONVITES</li>
                            <li>PODE FAZER CONEXÕES</li>
                            <li>ENVIA E RECEBE AVALIAÇÕES</li>
                            <li>PODE TROCAR MENSAGENS</li>
                            <li>PODE EXPORTAR DADOS DA PLATAFORMA</li>
                            <li>PODE SER CONVIDADO PARA EVENTOS EXCLUSIVOS</li>
                            <li>NO FUTURO - PODERÁ APROVEITAR INTERFACE COM OUTRAS PLATAFORMAS DO SETOR</li>
                        </ul>
                    `
                }
            ],
            items: [
                {
                    heading1: 'PRIMEIRAS INFORMAÇÕES',
                    heading2: '',
                    heading3: 'X',
                    heading4: '',
                    heading5: '',
                    heading6: ''
                },
                // {
                //     heading1: 'SOBRE O(S) EMPREENDEDOR(ES)',
                //     heading2: '',
                //     heading3: '',
                //     heading4: 'X',
                //     heading5: '',
                //     heading6: ''
                // },
                {
                    heading1: 'SOBRE A INICIATIVA',
                    heading2: '',
                    heading3: '',
                    heading4: 'X',
                    heading5: '',
                    heading6: ''
                },
                {
                    heading1: 'PLANEJAMENTO & GESTÃO',
                    heading2: '',
                    heading3: '',
                    heading4: '',
                    heading5: 'X',
                    heading6: ''
                },
                {
                    heading1: 'SUSTENTABILIDADE FINANCEIRA',
                    heading2: '',
                    heading3: '',
                    heading4: '',
                    heading5: 'X',
                    heading6: ''
                },
                {
                    heading1: 'REDES & PARCEIROS',
                    heading2: '',
                    heading3: '',
                    heading4: 'X',
                    heading5: '',
                    heading6: ''
                },
                {
                    heading1: 'RESULTADOS & IMPACTOS',
                    heading2: '',
                    heading3: '',
                    heading4: '',
                    heading5: 'X',
                    heading6: 'X'
                },
                {
                    heading1: 'GOVERNANÇA',
                    heading2: '',
                    heading3: '',
                    heading4: '',
                    heading5: '',
                    heading6: 'X'
                }
            ]
        }
    },
    methods: {
        showModal() {
            this.$refs['benefits-modal-ref'].show()
        }
    },
    computed: {
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        }
    }
}
</script>

<style scope src="./BenefitsPage-light-theme.css"></style>
<style scope src="./BenefitsPage-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/pages/private/dashboard-page/benefits-page/BenefitsPage.vue